export const HOME_PAGE_LINK = 'https://richr.com';
export const BLOG_LINK = 'https://richr.com/blog';
export const MANIFESTO_LINK = `${BLOG_LINK}/manifesto/`;
export const TERMS_AND_PRIVACY_LINK = `${BLOG_LINK}/terms-of-service/`;
export const PRIVACY_LINK = `${BLOG_LINK}/privacy-policy/`;
export const FAQ_LINK = `${BLOG_LINK}/faqs/`;
export const RICHR_HOMES_LINK = 'https://homes.richr.com/';
